import { sum } from "@faire/retailer-visitor-shared/lib/sum";
import { logWarning } from "@faire/web--source/common/logging";
import { ISizingQuantity } from "@faire/web-api--source/indigofair/data/ISizingQuantity";

export const getPrePackSize = (sizing_quantity: ISizingQuantity[]) => {
  const size = sum(sizing_quantity.map((item) => item.quantity ?? 0));
  if (isNaN(size) || size <= 0) {
    logWarning(
      `Received badly formed prepack sizing_quantity: ${sizing_quantity}`
    );
    return 1;
  }
  return size;
};
